import type { ColorScheme } from '@hivewatch/dark'

import { GridAnalysisJob } from '@/graphql/generated/schemas'

import { IncidentOptionI } from '../../types/types'
import { GridTestErrorCard } from './GridTestErrorCard'
import { GridTestSuccessCard } from './GridTestSuccessCard'

interface ResultsStepIProps {
  colorScheme?: ColorScheme
  variant: 'success' | 'error'
  job?: GridAnalysisJob
  labeledIn?: number
  labeledOut?: number
  isSaving?: boolean
  isTimeout?: boolean
  onClose: () => void
  onSelectAnotherIncident: () => void
  onSaveGrid?: () => void
  onRetry?: () => void
  selectedIncident: IncidentOptionI | null
}

export const ResultsStep = ({
  colorScheme,
  variant,
  job,
  labeledIn = 0,
  labeledOut = 0,
  isSaving = false,
  isTimeout = false,
  onClose,
  onSelectAnotherIncident,
  onSaveGrid,
  onRetry,
  selectedIncident,
}: ResultsStepIProps) => {
  if (variant === 'error') {
    return (
      <GridTestErrorCard
        colorScheme={colorScheme}
        isTimeout={isTimeout}
        onClose={onClose}
        onRetry={onRetry}
        onSelectAnotherIncident={onSelectAnotherIncident}
        selectedIncident={selectedIncident}
      />
    )
  }

  // The success branch requires `job` and `onSaveGrid`; GridTestingZone only
  // renders variant='success' when the job has completed, so these are
  // guaranteed at this point.
  return (
    <GridTestSuccessCard
      colorScheme={colorScheme}
      isSaving={isSaving}
      job={job}
      labeledIn={labeledIn}
      labeledOut={labeledOut}
      onClose={onClose}
      onSaveGrid={onSaveGrid}
      onSelectAnotherIncident={onSelectAnotherIncident}
      selectedIncident={selectedIncident}
    />
  )
}
